import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { renderRichText } from "@/components/bloks/utils";
import { Accordion } from "@/components/ui/Accordion";
import { Prose } from "@/components/ui/Prose";
import { Typography } from "@/components/ui/Typography";
import type { AccordionSectionGroupStoryblok } from "@/generated/sb/sb-types";

export const AccordionSectionGroupBlok = ({
	blok,
	darkMode,
}: BlokProps<AccordionSectionGroupStoryblok> & {
	darkMode?: boolean;
}) => {
	return (
		<BlokWrap editable={blok}>
			<div className="flex w-full flex-col gap-grid-section-vertical-md">
				{blok.title && (
					<Typography
						variant="heading-display-xs"
						as="h3"
						className={clsx(
							"text-text-dark-text-1 uppercase",
							darkMode && "text-text-light-text-1",
						)}
					>
						{blok.title}
					</Typography>
				)}
				<Accordion
					size="large"
					items={(blok.items ?? [])
						.filter((item) => typeof item !== "string")
						.map((item) => ({
							id: item.uuid,
							title: item.content.question,
							content: <Prose>{renderRichText(item.content.answer)}</Prose>,
						}))}
					darkMode={darkMode}
				/>
			</div>
		</BlokWrap>
	);
};
